import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { useCallback, useEffect, useRef } from 'react'

const FLASH_DURATION_MS = 500

/**
 * Temporarily highlights entities to 'flash' a change and indicate it to the
 * user. Highlighting also expands the phase the entities belong to.
 */
export const useFlashEntities = () => {
  const cubeContext = useCubeContext()
  const highlightedEntityIdsRef = useRef(
    cubeContext.queries.rawData.editor.highlightedEntityIds
  )

  // Clear against the latest highlights rather than the ones at flash time.
  useEffect(() => {
    highlightedEntityIdsRef.current =
      cubeContext.queries.rawData.editor.highlightedEntityIds
  }, [cubeContext.queries.rawData.editor.highlightedEntityIds])

  return useCallback(
    (entityIds: string[]) => {
      if (!entityIds.length) {
        return
      }

      cubeContext.mutators.updateEditor({
        highlightedEntityIds: entityIds
      })

      /**
       * Deliberately not cancelled on unmount: the editors flash a change and
       * then navigate away, and the highlight still has to be cleared.
       */
      setTimeout(() => {
        cubeContext.mutators.updateEditor({
          highlightedEntityIds: highlightedEntityIdsRef.current.filter(
            id => !entityIds.includes(id)
          )
        })
      }, FLASH_DURATION_MS)
    },
    [cubeContext.mutators]
  )
}
